import { useCallback, useState } from "react";

import type { Address, Policyholder } from "@covertree/new-business-graphql";
import { formatAddressToString } from "@covertree/utils";

import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  MailingAddressForm,
  UpdateMailingAddressModal,
} from "./UpdateMailingAddressModal";

interface Props {
  onMailingAddressSubmit(data: MailingAddressForm): Promise<void>;
  propertyAddress: Address;
  policyholder: Policyholder;
}

export function Addresses({
  onMailingAddressSubmit,
  propertyAddress,
  policyholder: { hasActivePolicies, mailingAddress },
}: Props) {
  const [mailingAddressModalOpen, setMailingAddressModalOpen] = useState(false);

  const openMailingAddressModal = useCallback(() => {
    setMailingAddressModalOpen(true);
  }, []);

  const closeMailingAddressModal = useCallback(() => {
    setMailingAddressModalOpen(false);
  }, []);

  return (
    <>
      <Card>
        <CardContent>
          <Stack direction="column" spacing={3}>
            <Stack direction="column" spacing={1}>
              <Typography variant="h6" color="textSecondary">
                Property address
              </Typography>
              <Typography variant="h5">
                {formatAddressToString(propertyAddress)}
              </Typography>
            </Stack>
            <Stack
              direction="row"
              spacing={1}
              alignItems="flex-end"
              justifyContent="space-between">
              <Stack direction="column" spacing={1}>
                <Typography variant="h6" color="textSecondary">
                  Mailing address
                </Typography>
                <Typography variant="h5">
                  {formatAddressToString(mailingAddress)}
                </Typography>
              </Stack>
              <Button
                variant="outlined"
                size="small"
                onClick={openMailingAddressModal}
                data-testid="mailing-address-open-dialog-button"
                disabled={!!hasActivePolicies}>
                Edit
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
      <UpdateMailingAddressModal
        mailingAddress={mailingAddress}
        onClose={closeMailingAddressModal}
        onSubmit={onMailingAddressSubmit}
        open={mailingAddressModalOpen}
      />
    </>
  );
}
